import { gql } from "@apollo/client";
export const UpdateClients = gql`
	mutation UpdateClient(
		$id: String!
		$name: String
		$email: String
		$phoneNumber: String
		$nif: String
		$address: String
		$postalCode: String
		$localidade: String
	) {
		updateClient(
			id: $id
			input: {
				name: $name
				email: $email
				phoneNumber: $phoneNumber
				nif: $nif
				addressInfo: { Address: $address, postalCode: $postalCode }
				localidade: $localidade
			}
		) {
			_id
			name
			email
			phoneNumber
			nif
			localidade
			addressInfo {
				Address
				postalCode
			}
		}
	}
`;
